import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../seguranca/auth.service';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent  implements OnInit {

  fromUrl: string;
  loginForm: UntypedFormGroup;
  resetForm: UntypedFormGroup;

  // Responsável por indicar se uma alteração de senha está acontecendo.
  userIsChangingPassword: boolean;

  // Responsável por indicar se o usuário selecionou a opção Esqueceu a senha ou tem o status Redefinir senha.
  userNeedsConfirmationCode: boolean;

  constructor(private formBuilder: UntypedFormBuilder, private authService: AuthService, private router: Router,
          private toast: ToastrService) { }

  ngOnInit(): void {
      // inscrever nos parâmetros de rota, toda a vez que ele mudar mesmo que o componente tenha sido carregado, uma ação será executada.
      // this.activatedRoute.params.subscribe(params => {
      //   this.fromUrl = params.fromUrl;
      // });

      // Se o usuário tiver um token válido rederecionar ele para o home component
      if (!this.authService.isAccessTokenInvalido()) {
        this.router.navigate(['/home']);
      }

      // Form para validar o login do usuário
      this.loginForm = this.formBuilder.group({
          email: ['',
              [
                  Validators.required,
                  Validators.email
              ]
          ],
          password: ['', Validators.required]
      });

      // Form para o usuário recuperar a senha.
      this.resetForm = this.formBuilder.group({
        email: ['',
            [
                Validators.required,
                Validators.email
            ]
        ]
    });

    // Setar e-mail do usuário logado na tela inicial.
    const email = localStorage.getItem('emailUsuario');
    if (email != null) {
      this.loginForm.get('email').setValue(email);
    }
  }

  login() {
    const userName = this.loginForm.get('email').value;
    const password = this.loginForm.get('password').value;

    this.authService.login(userName, password).subscribe(
          () => {
              // Redirecionar o usuário para URL padrão ou para a que ele digitou.
              this.fromUrl ?
                  this.router.navigateByUrl(this.fromUrl) : this.router.navigate(['home']);
          },
          () => {
              this.loginForm.get('password').reset();
              this.toast.error('Usuário ou senha inválidos!');
          }
      );
  }

  // Método responsável por indicar quando o login deve aparecer.
  shouldShowLogin() {
    return !this.userIsChangingPassword && !this.userNeedsConfirmationCode;
  }

  // Método responsável por indicar quando o solicitar alterar senha deve aparecer.
  isUserChangingPasswordByCode() {
    return !this.userIsChangingPassword && this.userNeedsConfirmationCode;
  }

  // Método responsável por solicitar a alteração da senha.
  solicitarNovaSenha() {
    // Remover Token do localStorage.
    localStorage.removeItem('token');
    const email = this.resetForm.get('email').value;

    this.authService.esqueceuSenha(email).subscribe(
      () => {
          this.toast.success('Instruções enviadas por e-mail');

          // Redirecionar o usuário para a tela de login.
          this.cleanStateVariables();
      },
      responseError => {
        if (responseError instanceof HttpErrorResponse) {
          if (responseError.status === 404) {
            this.toast.error('O e-mail informado é inexistente.');
          } else {
            this.toast.error('Ocorreu um erro ao processar a sua solicitação');
          }
        }
      }
    );
  }

  // Método responsável por voltar o login ao seu estado inicial.
  cleanStateVariables() {

    // Limpar variáveis da tela de login/esqueci senha
    this.loginForm.get('email').setValue(undefined);
    this.loginForm.get('password').setValue(undefined);
    this.resetForm.get('email').setValue(undefined);

    this.userIsChangingPassword = false;
    this.userNeedsConfirmationCode = false;

    localStorage.removeItem('token');
  }
}
